import React from 'react';
import { Button } from 'react-bootstrap';
import { RouteComponentProps } from 'react-router-dom';
import { CenterScreenComponent, DocumentForm, Link } from '../../components';
import { useDocumentQuery, useMeQuery, useGenerateResultQuery } from '../../generated/graphql';

interface GenerateResultScreenParams {
    id: string;
}

type GenerateResultScreenProps = RouteComponentProps<GenerateResultScreenParams>;

export const GenerateResultScreen: React.FC<GenerateResultScreenProps> = ({ match }) => {
    const id = match.params.id;
    const { data, loading, refetch, error } = useGenerateResultQuery({
        variables: { groupId: +id },
        fetchPolicy: 'no-cache',
    });

    if (loading) {
        return <CenterScreenComponent>Звантаження...</CenterScreenComponent>;
    }

    if (error) {
        return <CenterScreenComponent>Помилка...</CenterScreenComponent>;
    }

    return (
        <CenterScreenComponent>
            <Button
                as="a"
                style={{ margin: 5 }}
                href={data?.generateResult}
                target="_blank"
            >{`Завантажити результат`}</Button>
        </CenterScreenComponent>
    );
};
